module.exports = __webpack_public_path__ + "img/img-1.773d9f16.webp";